module.exports = __webpack_public_path__ + "static/oes.3c33dec5.png";